import ArrowLeft from "@/svg/ArrowLeft";
import DownArrowMinimal from "@/svg/DownArrowMinimal";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEligibilityDetailContext } from "../EligibilityDetailContext";
import CollapsiblePatientCard from "./CollapsiblePatientCard";
import HeaderDetails from "./HeaderDetails";
import "./PatientHeader.scss";

/**
 * Header strip at the top of the left column on the single-patient
 * eligibility details screen.
 *
 * @returns Header section populated from `GET /detail`
 */
const PatientHeader = () => {
  const navigate = useNavigate();
  const { header } = useEligibilityDetailContext();
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="single-patient-eligibility-details__left-header bg-blue-200">
      <div className="header-content flex min-h-[3.75rem] items-center gap-3 border-b border-primaryGray-14 bg-white px-4 py-2">
        <div
          className="navigation-icon hover:cursor-pointer hover:scale-105 transition-all"
          onClick={() => navigate("/eligibility")}
        >
          <ArrowLeft />
        </div>
        <div className="name-initial bg-[#00BC7D] h-8 w-8 flex items-center justify-center text-white text-small font-bold rounded-full">
          {header.initials}
        </div>
        <div className="basic-data min-w-0 flex-1">
          <HeaderDetails
            name={header.name}
            mrn={header.mrn}
            dobWithAge={header.dobWithAge}
            sex={header.sex}
            eligibilityStatus={header.eligibilityStatus}
            eligibilityTier={header.eligibilityTier}
            screeningSummary={header.screeningSummary}
            additionalStudies={header.additionalStudies}
            fhirIdentifier={header.fhirIdentifier}
          />
        </div>
        <div
          className={`accordion-action-btn hover:cursor-pointer hover:scale-105 transition-all${
            isExpanded ? " accordion-action-btn--expanded" : ""
          }`}
          onClick={() => setIsExpanded((expanded) => !expanded)}
        >
          <DownArrowMinimal />
        </div>
      </div>
      <CollapsiblePatientCard
        isExpanded={isExpanded}
        data={header.collapsibleFields}
      />
    </div>
  );
};

export default PatientHeader;
